export const Hi3dIcon = ({ width = 24, height = 24 }: { width?: number | string; height?: number | string }) => (
  <img
    src="/menu-images/hitem3d.png"
    alt="Hi3D"
    draggable={false}
    width={width}
    height={height}
    style={{ borderRadius: 4 }}
  />
);
